import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import * as LessonsV3 from '../../model/v3/lessons';
import {LangProductMapper} from "../../services/utils/lang-mappers";
import {ManagerColV3RestService} from "../../services/rest/v3/manager-col-v3-rest.service";
import {ToastNotification, ToastNotificationsService} from "../../services/toast-notifications.service";

@Component({
    selector: 'app-create-students-credits-bundle',
    templateUrl: './create-students-credits-bundle.component.html',
    styleUrls: ['./create-students-credits-bundle.component.css'],
    standalone: false
})
export class CreateStudentsCreditsBundleComponent implements OnInit {
  @Input()
  schoolId: number;
  @Input()
  studentId: number;

  @Output()
  creditsAdded = new EventEmitter<LessonsV3.LessonBundle>();

  newBundle: Partial<LessonsV3.LessonBundleDetails> = {};
  availableProducts  = LangProductMapper.getCourseProducts();

  constructor(
    private managerRest: ManagerColV3RestService,
    private notifications: ToastNotificationsService) { }

  registerBundle() {
    const bundle: LessonsV3.LessonBundleDetails = {
      product: this.newBundle.product,
      date: new Date(),
      available: this.newBundle.available,
      expiryDate: this.newBundle.expiryDate,
      registeredLesson: this.newBundle.available,
      name: this.newBundle.name,
      price: this.newBundle.price,
      bundleDuration: this.newBundle.bundleDuration,
      note: this.newBundle.note,
    };

    this.managerRest.saveLessonBundle(this.schoolId, this.studentId, bundle)
    .subscribe( resBundle => {
      this.creditsAdded.emit(resBundle);
      this.newBundle = {};
      this.notifications.display(new ToastNotification("Credits added", "Students credits added correctly."))
    });
  }

  ngOnInit() {}
}
